/** Subscription tiers targeted by marketing popups (audience checkboxes). */
export const SUBSCRIPTION_PLANS = [
    "Only Free users",
    "Only Professional tier",
    "Only Elite tier",
    // "BSE",
    // "Stocks",
    "Only ECourse subscribers",
    "Only PRO2",
    "Everyone"
];

export const POPUP_MESSAGE_TYPES = [
    { value: "info", label: "Quick Info" },
    { value: "insight", label: "Insights" },
    { value: "action", label: "Action" },
];
